// src/pages/NotFound.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="not-found-icon">🔍</div>
        <h1 className="not-found-title">404 - Page Not Found</h1>
        <p className="not-found-message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="not-found-actions">
          <Link to="/" className="home-btn">
            ← Go Back Home
          </Link>
          <Link to="/products" className="products-btn">
            Browse Products
          </Link>
        </div>
        <div className="not-found-suggestions">
          <h3>You might be looking for:</h3>
          <ul>
            <li><Link to="/products">All Products</Link></li>

            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/specialist">Solar Specialist</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotFound;